<template>
  <div
    class="flex-column"
  >
    <Baseloader v-if="loading.typesCulture" />
    <div v-else>
      <div
        v-if="typesCultureMapped.length > 1"
      >
        <BaseSelect
          v-model="cultureSelected"
          :items="typesCultureMapped"
          :libelle-btn="cultureSelected.libelle"
          @onClick="onSelectCulture($event)"
        />
      </div>
      <div
        v-else
      >
        <v-chip
          outlined
          class="intro pa-5 --text-branche"
        >
          {{ cultureSelected.libelle }}
        </v-chip>
      </div>
      <Baseloader v-if="loading.resumeSyntheseCulture && erreur.resumeSyntheseCulture === null" />
      <BaseMessage
        v-if="erreur.resumeSyntheseCulture != null"
        class="ma-5"
        color="success"
        :message="erreur.resumeSyntheseCulture"
        text
        type="success"
      />
      <div v-if="!loading.resumeSyntheseCulture && erreur.resumeSyntheseCulture === null">
        <div
          v-if="resumeSyntheseCulture.montantChargesVariablesEnEuroParTonne != null"
          class="d-flex justify-space-between mt-3"
        >
          <span class="align-self-center texte texte-gris-fonce">
            Charges intrants
          </span>
          <span class="align-self-center titre-h4 secondary--text">
            {{ resumeSyntheseCulture.montantChargesVariablesEnEuroParTonne | roundNumber(0) }} €/t
          </span>
        </div>
        <div
          v-if="resumeSyntheseCulture.montantChargesFixesEnEuroParTonne != null"
          class="d-flex justify-space-between mt-3"
        >
          <div class="d-flex texte texte-gris-fonce">
            <span class="align-self-center ">
              <img
                alt="picto-operateur-plus"
                class="align-self-center"
                src="@/assets/picto-operateur-plus.svg"
              >
            </span>
            <span class="ml-2">Charges fixes
            </span>
          </div>
          <span class="align-self-center titre-h4 secondary--text">
            {{ resumeSyntheseCulture.montantChargesFixesEnEuroParTonne | roundNumber(0) }} €/t
          </span>
        </div>
        <div
          v-if="resumeSyntheseCulture.montantCoproduitsEnEuroParTonne!= null"
          class="d-flex justify-space-between mt-3"
        >
          <div class="d-flex texte texte-gris-fonce">
            <span class="align-self-center">
              <img
                alt="picto-operateur-moins"
                class="align-self-center"
                src="@/assets/picto-operateur-moins.svg"
              >
            </span>
            <span class="ml-2">Co-produits
            </span>
          </div>
          <span
            class="align-self-center titre-h4 secondary--text"
          >
            {{ resumeSyntheseCulture.montantCoproduitsEnEuroParTonne | roundNumber(0) }} €/t
          </span>
        </div>
        <div
          v-if="resumeSyntheseCulture.montantAutresProduitsEnEuroParTonne!= null"
          class="d-flex justify-space-between mt-3"
        >
          <div class="d-flex texte texte-gris-fonce">
            <span class="align-self-center ">
              <img
                alt="picto-operateur-moins"
                class="align-self-center"
                src="@/assets/picto-operateur-moins.svg"
              >
            </span>
            <span class="ml-2">Aides PAC et autres produits
            </span>
          </div>
          <span
            class="align-self-center titre-h4 secondary--text"
          >
            {{ resumeSyntheseCulture.montantAutresProduitsEnEuroParTonne | roundNumber(0) }} €/t

          </span>
        </div>
        <div
          class="d-flex justify-center chiffre-xxl secondary--text mt-4"
        >
          {{ resumeSyntheseCulture.prixEquilibreEnEuroParTonne | roundNumber(0) }} €/t
        </div>
        <v-divider
          v-if="resumeSyntheseCulture.rendementEnQuintauxParHectare!= null"
          class="my-4"
        />
        <div
          v-if="resumeSyntheseCulture.rendementEnQuintauxParHectare!= null"
          class="d-flex justify-space-between"
        >
          <span class="align-self-center intro --text-branche">
            Rendement
          </span>
          <span
            
            class="align-self-center titre-h4 --text-branche"
          >
            {{ resumeSyntheseCulture.rendementEnQuintauxParHectare | roundNumber(0) }} qx/ha
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import Baseloader from '@/components/common/base-loader.vue'
import BaseMessage from '@/components/common/base-message.vue'
import BaseSelect from '@/components/common/base-select.vue'

export default {
  name: 'MonPrixEquilibre',
  components: {Baseloader, BaseMessage, BaseSelect},
  props: {
  },
  data () {
    return {
      loading: {
        typesCulture: false,
        resumeSyntheseCulture: false
      },
      erreur: {
        typesCulture: false,
        resumeSyntheseCulture: false
      },
      cultureSelected: null
    }
  },
  computed: {
    ...mapGetters({
      codeGraineActive: 'application/codeGraineActive',
      anneeRecolteActive: 'application/anneeRecolteActive',
      typesCulture: 'culture/typesCulture',
      resumeSyntheseCulture:'cloture/resumeSynthese'
    }),

    typesCultureMapped () {
      return this.typesCulture.map(culture => ({
        id: culture.id,
        code: culture.code,
        libelle: culture.nom
      }))
    }
  },

    watch: {   
    anneeRecolteActive () {
      this.loadCultures()
    },
    codeGraineActive: {
      handler () {
        if (this.codeGraineActive != null) {
          this.loadCultures()
        }
      },
      immediate: true
    }
  },

  methods: {
    ...mapActions({
      findAllTypesCulturesActiveByRs3: 'culture/findAllTypesCulturesActiveByRs3',
      getResumeSyntheseCulture:'cloture/getResumeSyntheseCulture'
    }),
    loadCultures () {
      this.loading.typesCulture = true
      this.erreur.typesCulture = false
      this.findAllTypesCulturesActiveByRs3(this.codeGraineActive)
        .then(() => {
          this.cultureSelected = this.typesCultureMapped[0]
          this.$emit('culture-selectionnee', this.cultureSelected ? this.cultureSelected.code : null)
          this.loadResumeSyntheseCulture()
        })
        .catch(() => {
          this.erreur.typesCulture = true
        })
        .finally(() => {
        this.loading.typesCulture = false
      })
    },
    loadResumeSyntheseCulture () {
      this.erreur.resumeSyntheseCulture = null
      this.loading.resumeSyntheseCulture = true
      this.getResumeSyntheseCulture(this.cultureSelected.code)
        .catch((error) => {
        this.erreur.resumeSyntheseCulture = error.response.data.message
      })
      .finally(() => {
      this.loading.resumeSyntheseCulture = false
    })
    },
    onSelectCulture (code) {
      this.cultureSelected = this.typesCultureMapped.find(t => t.code === code)
      this.$emit('culture-selectionnee', this.cultureSelected ? this.cultureSelected.code : null)
      this.loadResumeSyntheseCulture()
    }
  }
}
</script>
<style lang="scss" scoped>
.text-align-center {
  text-align: center;
}
</style>